import React, { useState } from 'react'
import ColorPickerV2 from 'src/components/common/ColorPickerV2'
import { InputSlider } from 'src/components/common/slider/InputSlider'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@shopflo/ui'
import { BorderSides, BORDER_SIDES_OPTIONS } from '../config'
import { useCartContext } from 'src/lib/contexts/CartContext'
import { SLIDER_CONSTANTS } from 'src/lib/utils/constants'

interface NotesConfigType {
  backgroundColor: string
  textColor: string
  cardRadius: number
  cardBorderWidth: number
  cardBorderSides: BorderSides
  borderColor: string
}

export const NotesControl = () => {
  const {
    getters: { cartUIData },
    actions: { setCartUIConfigData }
  } = useCartContext()

  const handleConfigChange = (updates: Partial<NotesConfigType>) => {
    setCartUIConfigData({ ...cartUIData.notesConfig, ...updates }, 'NOTES')
  }

  return (
    <div className='flex flex-col gap-5'>
      {/* Color Pickers Row */}
      <div className='grid grid-cols-2 gap-2'>
        <ColorPickerV2
          label='Background'
          color={cartUIData.notesConfig.backgroundColor}
          onChange={color => handleConfigChange({ backgroundColor: color })}
        />
        <ColorPickerV2
          label='Text'
          color={cartUIData.notesConfig.textColor}
          onChange={color => handleConfigChange({ textColor: color })}
        />
        <ColorPickerV2
          label='Border'
          color={cartUIData.notesConfig.borderColor}
          onChange={color => handleConfigChange({ borderColor: color })}
        />
      </div>

      {/* Card Radius */}
      <InputSlider
        label='Card radius'
        value={cartUIData.notesConfig.cardRadius}
        onChange={value => handleConfigChange({ cardRadius: value })}
        min={0}
        max={SLIDER_CONSTANTS.MAX_RADIUS}
        step={1}
        showDots={true}
        dotCount={5}
        unit='px'
      />

      {/* Card Border Width */}
      <div className='flex flex-col gap-1'>
        <InputSlider
          label='Card border'
          value={cartUIData.notesConfig.cardBorderWidth}
          onChange={value => handleConfigChange({ cardBorderWidth: value })}
          min={0}
          max={SLIDER_CONSTANTS.MAX_BORDER_WIDTH}
          step={1}
          showDots={true}
          dotCount={5}
          unit='px'
        />

        {/* Card Border Sides Selector */}
        <div className='flex items-center justify-end gap-2 mt-1'>
          <Select
            value={cartUIData.notesConfig.cardBorderSides}
            onValueChange={(value: BorderSides) => handleConfigChange({ cardBorderSides: value })}
          >
            <SelectTrigger className='w-[178px] h-8 bg-white'>
              <SelectValue placeholder='Select sides' />
            </SelectTrigger>
            <SelectContent>
              {BORDER_SIDES_OPTIONS.map(option => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  )
}
